import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/from-template', 'post'>;
type ResponseBody = OASOutput<O, '/api/projects/from-template', 'post'>;

type Params = {
  templateIdentifier: string;
};

type Result = {
  id: number;
  name: string;
};

export const createProjectFromTemplateFactory = (apiClient: ApiClient) => {
  const createProjectFromTemplate = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects/from-template'].post(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        templateIdentifier: input.templateIdentifier,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      name: response.name,
    };
  };

  return createProjectFromTemplate;
};
